import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import {EventLoggerService} from '@services/event-logger-service';

@Component({
  selector: 'app-complete-your-multiple-order',
  templateUrl: './complete-your-multiple-order.component.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class CompleteYourMultipleOrderComponent implements OnInit {
  @Input('toolbarIcons') toolbarIcons:any;
  @Output('goToCart') goToCart:EventEmitter<void> = new EventEmitter();
  @Input('productsInCart') productsInCart:any;
  @Input('cartDiscount') cartDiscount:number;
  @Input('numberOfProductsInCart') numberOfProductsInCart:number;
  @Input('userDrImage') userDrImage: string;
  containsDrAddedProduct: boolean = false;
  containsScriptAddedProducts: boolean = false;
  @Input('totalSp') totalSp:any;
  @Input() cartScriptBannerHeaderExperiment!: boolean;
  @Input() isShopRevampExperimentOn: boolean = false;
  ngOnInit(): void {
    this.containsDrAddedProduct = this.productsInCart?.some((each: any): any => each.isDoctorAdded);
    this.containsScriptAddedProducts = this.productsInCart?.some((each: any): any => each.isAddedByScript);
  }

  constructor(
    private readonly eventLogger: EventLoggerService,
  ) {
  }

  handleClick(): void {
    this.goToCart.emit();
    const eventType = this.productsInCart[0]?.isDoctorAdded ? 'doctor_added_multi' : 'user_added_multi';
    this.eventLogger.cleverTapEvent('Buy_Now_Cart_banner_HP_clicked', JSON.stringify({ type: eventType }));
  }

  get showReorderKitHeader(): boolean {
    return this.containsScriptAddedProducts && this.cartScriptBannerHeaderExperiment;
  }

  get showDoctorAddedHeader(): boolean {
    return this.containsDrAddedProduct && (!this.cartScriptBannerHeaderExperiment || !this.containsScriptAddedProducts);
  }

  get showCompleteOrderHeader(): boolean {
    return !this.containsDrAddedProduct;
  }
}
